import { Component, OnInit } from '@angular/core';
import { QuestionnaireService } from '../services/questionnaire.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
	selector: 'app-financing-sources',
	templateUrl: './financing-sources.component.html',
	styleUrls: ['./financing-sources.component.scss']
})
export class FinancingSourcesComponent implements OnInit {
	private route$: Subscription;
	prevQID: any;
	qID;
	sourceCapital = [{ 'source': '', 'amount': '', readOnly: false }];
	visibleQids;
	editQuestion;
	currentStep;
	financingSources: FormGroup;
	submitted;
	warnInfo = false;

	qFields = {
		1: [{ name: "haveMoreLoan" }],
		2: [{ name: "loanPropose", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }],
		3: [{ name: "loanAmount", validators: [Validators.required] }]
	};

	qArrFields = {
	};


	constructor(
		private questionnaireService: QuestionnaireService,
		private activeRoute: ActivatedRoute,
		private router: Router,
		private fb: FormBuilder
	) { }

	ngOnInit() {
		this.createForm();

		this.route$ = this.activeRoute.params.subscribe(params => {
			console.log("-----------------------------> params", params);
			this.prevQID = this.qID;
			this.qID = params.qid;
			this.editQuestion=null;

			if (params.qid === "all") {
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			} else {
				this.setValidators();
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			}
		});
	}

	createForm() {
		this.currentStep = this.questionnaireService.getStep("financing-sources");
		this.financingSources = this.fb.group({
			haveMoreLoan: this.questionnaireService.getQuestion(this.currentStep, "1").selectedAnswer,
			loanPropose: this.questionnaireService.getQuestion(this.currentStep, "2").answer.fields[0].answerValue,
			loanAmount: this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[0].answerValue
		});
	}

	setValidators() {
		this.questionnaireService.clearAllQuestionValidators(this.financingSources.controls, this.qFields, this.qArrFields);
		this.questionnaireService.setCurrentQuestionValidators(this.qID, this.financingSources.controls, this.qFields, "6", this.qID === "1"?this.qArrFields:null, false);
		
		this.submitted = false;
	}

	nextClick(qID, answers) {
		if (answers) {
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
		}
	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit", value);
		this.submitted = true;
		if (valid) {
			let q;
			let submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;

			q = this.qFields[submitQID];

			let values = q.map(r => value[r.name]);
			this.questionnaireService.sendGA(this.currentStep,this.qID, values);
			this.nextClick(submitQID, values);
		}
		console.log("Reactive Form submitted: ", this.financingSources)
	}

	editQuestionChange(qid){
		this.qID = qid;
		this.setValidators();
	}
}



// WEBPACK FOOTER //
// ./src/app/financing-sources/financing-sources.component.ts